// src/components/ui/checkbox.js
import React from 'react';
import { useConfig } from '../../context/ConfigContext';

export const Checkbox = ({ checked, onCheckedChange, className }) => {
  const { config } = useConfig();
  
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onCheckedChange(e.target.checked)}
      className={`h-4 w-4 rounded ${className}`}
      style={{ 
        borderColor: `${config.colors.textSecondary}50`,
        accentColor: config.colors.primary
      }}
    />
  );
};

// // src/components/ui/checkbox.js
// import React from 'react';
// export const Checkbox = ({ checked, onCheckedChange, className }) => (
//   <input
//     type="checkbox"
//     checked={checked}
//     onChange={(e) => onCheckedChange(e.target.checked)}
//     className={`h-4 w-4 rounded border-gray-300 ${className}`}
//   />
// );
